import * as React from 'react';
import classNames from 'classnames';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown } from '@material-ui/icons';
import { Box, Menu } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: '#F6F6F6'
      }
    },
    focusedTitle: {
      backgroundColor: '#EEEEEE'
    },
    menu: {
      minWidth: '10'
    }
  })
);

type Props = {
  title: React.ReactNode;
  children: React.ReactNode;
};

export const DropdownMenu: React.FC<Props> = ({ title, children }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorWidth, setAnchorWidth] = React.useState<number>(0);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setAnchorWidth(event.currentTarget.offsetWidth);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!children || (Array.isArray(children) && children.length === 0)) {
    return (
      <Box className={classes.title} style={{ cursor: 'default' }}>
        {title}
      </Box>
    );
  }

  return (
    <>
      <Box className={classNames(classes.title, Boolean(anchorEl) && classes.focusedTitle)} onClick={handleClick}>
        {title}
        <ArrowDropDown />
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        className={classes.menu}
        disableAutoFocusItem
        PaperProps={{
          style: { width: anchorWidth }
        }}
      >
        {children}
      </Menu>
    </>
  );
};
